<script setup>
import { reactive, ref } from "vue";
// - LRR import { useMainStore } from "@/stores/main";
import {
	mdiAccount,
	mdiMail,
	mdiAsterisk,
	mdiFormTextboxPassword,
	mdiGithub,
	mdiCog
} from "@mdi/js";
import SectionMain from "@/Components/SectionMain.vue";
import CardBox from "@/Components/CardBox.vue";
import BaseDivider from "@/Components/BaseDivider.vue";
import FormField from "@/Components/FormField.vue";
import FormControl from "@/Components/FormControl.vue";
import FormFilePicker from "@/Components/FormFilePicker.vue";
import BaseButton from "@/Components/BaseButton.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import UserCard from "@/Components/UserCard.vue";
//import LayoutAuthenticated from "@/layouts/LayoutAuthenticated.vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import SectionTitleLineWithButton from "@/Components/SectionTitleLineWithButton.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeButton from '@/Components/Button.vue';
import { Inertia } from '@inertiajs/inertia';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import TableSingle from "@/Components/TableSingle.vue";
import BaseIcon from "@/Components/BaseIcon.vue";

// LRR
const props = defineProps({
	//object: Object,
	message: String,
	objects: Array,
	modulo: String,
	rutaprefijo: String,
	title: String,
	isRef: Boolean,
	param: Object
});

const data = { userName: 'Lenin', userEmail: 'lenin@leninrias.com', userAvatar: '../img/logo.png' }

// LRR
//const mainStore = useMainStore();
const mainStore = data;
const pinSecurity = ref('')
//const mainStore = props.userData;
// Hola

/* const profileForm = reactive({
  name: mainStore.userName,
  email: mainStore.userEmail,
}); */

const profileForm = reactive({
	name: props.object ? props.object.name : '',
	email: props.object ? props.object.email : '',
});

//console.log(props.object)

const passwordForm = reactive({
	password_current: "",
	password: "",
	password_confirmation: "",
});

// LRR se  trajo de main store
const setUser = (payload) => {
	if (payload.name) {
		profileForm.userName = payload.name;
	}
	if (payload.email) {
		profileForm.userEmail = payload.email;
	}
	if (payload.avatar) {
		profileForm.userAvatar = payload.avatar;
	}
}

const submitProfile = () => {
	// - LRR mainStore.setUser(profileForm);
	//setUser(profileForm);
	let ruta = 'perfil-actualizar'
	Inertia.put(route(ruta, {
		//'id' : rowID.value,
		'name': profileForm.name,
		'email': profileForm.email
	}
	))

};

const submitPass = () => {
	//
	let ruta = 'password-actualizar'
	Inertia.put(route(ruta, {
		//'id' : rowID.value,
		'password': passwordForm.password,
		'password_confirmation': passwordForm.password_confirmation
	}
	))
};
</script>

<template>
	<Head title="Mi Perfil" />

	<BreezeAuthenticatedLayout>

		<!--<template #header>
        <h2 class="font-semibold text-xl text-gray-800 leading-tight">
            Mi perfil
        </h2>
      </template>-->
		<template #header>
			<div class="min-h-[73px] flex justify-between">
				<div class="min-h-[73px] flex justify-center flex-col">
					<h2 class="font-semibold text-sm lg:text-base text-gray-800 leading-tight">
						Panel de opciones avanzadas
					</h2>
				</div>
				<!-- <div class="min-h-[73px] flex items-center">
                   
                        <BaseButton
                    href="https://github.com/justboil/admin-one-vue-tailwind"
                    :icon="mdiGithub"
                    target="_blank"
                    label="Star on GitHub"
                    color="contrast"
                    rounded-full
                    small
                    />
                    
                </div> -->
			</div>
		</template>

		<SectionMain class="!p-0">
			<BreezeValidationErrors class="mb-4" />
			<div v-if="message">
				<!-- <div class="font-medium text-red-600">Ups! Algo está mal.</div> -->
				<ul class="mt-3 list-disc list-inside text-sm text-green-600">
					<!-- <li v-for="(error, key) in errors" :key="key">{{ error }}</li> -->
					<li>{{ message }}</li>
				</ul>
			</div>

			<div class="py-8 lg:py-10">
				<div class="mx-auto sm:px-6 lg:px-8 px-4">
					<div class="bg-white border shadow-lg rounded-md p-4">
						<!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
						<div class="mb-4">
							<div v-if="pinSecurity != confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY">
								<p class="text-sm inline-block mr-4 mt-4 ">Para realizar cambios ingrese el Pin de seguridad (no se verá lo que escribe) </p><input id="pin_security" name="pin_security" type="text" class="text-transparent mt-3" v-model="pinSecurity" autocomplete="off" title="Si selecciona el campo podrá ver lo que escribió">
							</div>
						</div>
						<CardBox class="mb-6" has-table>
							<!-- Tablesingle opciones: checkable -->
							<div class="overflow-x-auto">
								<TableSingle :isRef="isRef" :modulo="modulo" :data="objects" :ruta="rutaprefijo" originType="opciones-avanzadas" nocreate nostatus :noupdate="(pinSecurity == confGlobal.value.CONSTANT_PIN_SECURITY_MODIFY ? false : true)" tableclass="table-basic" :param="param" />
							</div>
						</CardBox>

					</div>
				</div>
			</div>



			<!-- <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <CardBox is-form @submit.prevent="submitProfile">

          <FormField label="Nombre para mostrar" help="Nombre corto o Nickname">
            <FormControl
              v-model="profileForm.name"
              :icon="mdiAccount"
              name="username"
              required
              autocomplete="username"
            />
          </FormField>
          <FormField label="E-mail" help="Email de acceso al sistema">
            <FormControl
              v-model="profileForm.email"
              :icon="mdiMail"
              type="email"
              name="email"
              required
              autocomplete="email"
            />
          </FormField>

          <template #footer>
            <BaseButtons>
              <BaseButton color="info" type="submit" label="Guardar" />
            </BaseButtons>
          </template>
        </CardBox>

        <CardBox is-form @submit.prevent="submitPass">


          <FormField label="Nuevo password" help="Ingrear nuevo password">
            <FormControl
              v-model="passwordForm.password"
              :icon="mdiFormTextboxPassword"
              name="password"
              type="password"
              required
              autocomplete="new-password"
            />
          </FormField>

          <FormField
            label="Confirmar password"
            help="Ingregar el nuevo password una vez más"
          >
            <FormControl
              v-model="passwordForm.password_confirmation"
              :icon="mdiFormTextboxPassword"
              name="password_confirmation"
              type="password"
              required
              autocomplete="new-password"
            />
          </FormField>

          <template #footer>
            <BaseButtons>
              <BaseButton type="submit" color="info" label="Guardar" />
            </BaseButtons>
          </template>
        </CardBox>
      </div> -->
		</SectionMain>
	</BreezeAuthenticatedLayout>
</template>
